import React from "react";
import ReactDOM from "react-dom";

interface CustomModalContainerProps {
  open: boolean;
  onClose?: () => void;
  title?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

const CustomModalContainer: React.FC<CustomModalContainerProps> = ({
  open,
  onClose,
  title,
  children,
  footer,
}) => {
  if (!open) return null; // Do not render the CustomModalContainer if not open

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-40 flex items-end justify-end h-full bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-11/12 max-w-lg h-full overflow-y-auto flex flex-col">
        {/* CustomModalContainer Header */}
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          {title && <h2 className="text-lg font-semibold">{title}</h2>}
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 focus:outline-none"
            aria-label="Close CustomModalContainer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* CustomModalContainer Body */}
        <div className="p-6">{children}</div>

        {/* Modal Footer */}
        {footer && <div className="p-4 border-t border-gray-200 relative bottom-0 justify-self-end">{footer}</div>}
      </div>
    </div>,
    document.body
  );
};

export default CustomModalContainer;
